import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable, map } from 'rxjs';
// Imported by file rather than through the barrel, so core/auth and core/services do not import
// each other. See the matching note in workspace-context.service.ts.
import { WorkspaceContext } from 'app/core/services/workspace-context.service';
import { AuthGuard } from './auth.guard';

@Injectable({ providedIn: 'root' })
export class LabAdminRestrictedGuard implements CanActivate {
  private readonly router: Router = inject(Router);
  private readonly workspace: WorkspaceContext = inject(WorkspaceContext);
  private readonly authGuard: AuthGuard = inject(AuthGuard);

  /** Keeps LabAdmin accounts inside their own workspace while preserving broader Admin access. */
  public canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> {
    return this.authGuard.canActivate(next, state).pipe(
      map((isAuthenticated: boolean): boolean | UrlTree => {
        if (!isAuthenticated) {
          return false;
        }

        return this.workspace.owned === 'lab-admin'
          ? this.router.parseUrl(this.workspace.homeUrlOf('lab-admin'))
          : true;
      })
    );
  }
}
